import { Platform } from '../../../../hooks/usePlatform';

const MAC_SYMBOL_BY_KEY: Record<string, string> = {
  ctrl: '⌘',
  cmd: '⌘',
  meta: '⌘',
  shift: '⇧',
  alt: '⌥',
  option: '⌥',
};

export const isApplePlatform = (platform: Platform) =>
  platform === Platform.MAC_OS || platform === Platform.IOS;

export const buildShortcutKeys = (keys: string[], isApple: boolean) =>
  keys.map((key) => (isApple ? (MAC_SYMBOL_BY_KEY[key.toLowerCase()] ?? key) : key)).join(' ');
